import AUPostCollectionsViewController from './AUPostCollectionsViewController';

export default AUPostCollectionsViewController;
